import React from 'react';
import { useToggle } from 'ahooks';

import TaskInfo from '../Tasks/TaskInfo';

interface IShowTasksProps {}

const ShowTasks: React.FC<IShowTasksProps> = ({}) => {
  const [isShow, { toggle: toggleShow }] = useToggle(false);

  return (
    <div>
      <div
        className="m-auto flex w-[180px] cursor-pointer items-center justify-center  pt-6 text-center text-base font-medium text-neutral-100 underline"
        onClick={toggleShow}
      >
        {!isShow ? 'Show raffle tasks' : 'Hide raffle tasks'}
      </div>
      {isShow && (
        <div>
          <div className="mt-6 h-px bg-neutral-700"></div>
          <TaskInfo isShow={isShow} />
        </div>
      )}
    </div>
  );
};

export default ShowTasks;
